module.exports = "<navbar></navbar>\n\n<router-outlet></router-outlet>\n\n<footer></footer>"